export default __webpack_public_path__ + "static/media/quiz2_answer.e82a493e.jpg";